export const filterObject = (value: string, text: string): Object => {
	const obj = Object.create(null);
	obj[`${value}`] = text;
	return obj;
};
